var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useUpdateModuleMutation } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export default function InstalledModuleDisplay(_a) {
    var _this = this;
    var moduleObject = _a.moduleObject;
    var t = useTranslation(["Administration", "common"]).t;
    var _b = useState(null), prepareResult = _b[0], setPrepareResult = _b[1];
    var _c = useState(false), isLoad = _c[0], setLoad = _c[1];
    var updateModuleMutation = useUpdateModuleMutation()[0];
    var updateModule = function (method, step, id) { return __awaiter(_this, void 0, void 0, function () {
        var responseup;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    setLoad(true);
                    return [4 /*yield*/, updateModuleMutation({
                            method: method,
                            step: step,
                            body: {
                                package_id: id,
                                package: prepareResult,
                            },
                        })];
                case 1:
                    responseup = _k.sent();
                    if (((_a = responseup === null || responseup === void 0 ? void 0 : responseup.data) === null || _a === void 0 ? void 0 : _a.data) &&
                        ((_c = (_b = responseup === null || responseup === void 0 ? void 0 : responseup.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) === 0 &&
                        ((_e = (_d = responseup === null || responseup === void 0 ? void 0 : responseup.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.payload) &&
                        ((_g = (_f = responseup === null || responseup === void 0 ? void 0 : responseup.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.payload[0])) {
                        setLoad(false);
                        setPrepareResult((_j = (_h = responseup === null || responseup === void 0 ? void 0 : responseup.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.payload[1]);
                    }
                    else {
                        setLoad(false);
                        console.log("Erreur : voir log");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "configurator bg-[color:var(--colors-main-bg)] p-2 m-4 relative", style: { overflowY: "auto" } }, { children: [isLoad && _jsx(LoaderImage, {}), _jsx("h2", __assign({ className: "title" }, { children: moduleObject.name })), _jsx("div", __assign({ className: "description" }, { children: moduleObject.description })), _jsx("div", { children: moduleObject.version }), _jsx("div", { children: moduleObject.type }), _jsx("div", { children: moduleObject.published_date }), _jsx("div", { children: prepareResult === null ? (_jsxs(_Fragment, { children: [moduleObject.uninstallable === true &&
                            moduleObject.file_install && (_jsx("button", __assign({ className: "button primary", onClick: function () {
                                updateModule("uninstall", "prepare", moduleObject.file_install);
                            } }, { children: t("LBL_UW_UNINSTALL", { ns: "Administration" }) }))), moduleObject.uninstallable === true &&
                            moduleObject.file_install &&
                            moduleObject.enabled === "ENABLED" && (_jsx("button", __assign({ className: "button secondary", onClick: function () {
                                updateModule("disable", "prepare", moduleObject.file_install);
                            } }, { children: t("LBL_UW_DISABLE", { ns: "Administration" }) }))), moduleObject.uninstallable === true &&
                            moduleObject.file_install &&
                            moduleObject.enabled === "DISABLED" && (_jsx("button", __assign({ className: "button secondary", onClick: function () {
                                updateModule("enable", "prepare", moduleObject.file_install);
                            } }, { children: t("LBL_UW_ENABLE", { ns: "Administration" }) })))] })) : (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "button primary", onClick: function () {
                                updateModule("uninstall", "commit", prepareResult.fileId);
                            } }, { children: t("LBL_ML_COMMIT", { ns: "Administration" }) })), _jsx("button", __assign({ className: "button secondary", onClick: function () {
                                setPrepareResult(null);
                            } }, { children: t("LBL_ML_CANCEL", { ns: "Administration" }) }))] })) })] })));
}
